module.exports = __webpack_public_path__ + "static/media/actionImage.ff416ada.svg";